import createKeyIdentifierProvider from '@exodus/key-identifier-provider';
const createModuleDependencies = () => [
    {
        definition: {
            id: 'keyIdentifierProvider',
            type: 'module',
            factory: createKeyIdentifierProvider,
            dependencies: [],
        },
    },
];
export default createModuleDependencies;
